/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const StylesLibrary = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <path
      fill="#044389"
      fillRule="evenodd"
      d="M10.223 5.335a1.991 1.991 0 00-.979.015L2.483 7.162A2 2 0 001.069 9.61l2.847 10.625a2 2 0 002.45 1.414l6.76-1.811a2.01 2.01 0 00.393-.15l-2.8-.75a4 4 0 01-2.829-4.9l2.333-8.704z"
    />,
    <path
      fill="#327AFF"
      d="M12.67 3.932a2 2 0 012.449-1.414l6.761 1.811a2 2 0 011.415 2.45l-2.848 10.625a2 2 0 01-2.449 1.414l-6.761-1.812a2 2 0 01-1.415-2.449L12.67 3.932z"
    />,
  );
};

export default StylesLibrary;
